import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedBillingComponentsModule } from '@nationwide/dgs-angular-billing-common';
import { ISBSharedComponentsModule } from '../../shared/shared-components.module';
import { WaysToPayAdapter } from '../shared/adapters/ways-to-pay.adapter';
import { WaysToPayModalComponent } from './ways-to-pay-modal/ways-to-pay-modal.component';
import { WaysToPayComponent } from './ways-to-pay-widget/ways-to-pay.component';
import { TimeoutModalService } from '../../shared/session/time-out/time-out.service';
import { QuickPayFlowService } from '../../quick-pay/shared/services/quick-pay-flow/quick-pay-flow.service';

@NgModule({
    imports: [
        CommonModule,
        ISBSharedComponentsModule,
        SharedBillingComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        WaysToPayComponent,
        WaysToPayModalComponent
    ],
    exports: [
        WaysToPayComponent,
        WaysToPayModalComponent
    ],
    providers: [
        WaysToPayAdapter,
        TimeoutModalService,
        QuickPayFlowService
    ]
})
export class WaysToPayModule { }
